export const CAMPAIGN_HEADER_TEST_ID = 'campaign-header';

export const CAMPAIGN_HEADER_DETAILS_TEST_ID = `${CAMPAIGN_HEADER_TEST_ID}-details`;
export const CAMPAIGN_HEADER_DETAILS_CAMPAIGN_ID_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-campaign-id`;
export const CAMPAIGN_HEADER_DETAILS_CAMPAIGN_TYPE_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-campaign-type`;
export const CAMPAIGN_HEADER_DETAILS_CREATED_ON_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-created-on`;
export const CAMPAIGN_HEADER_DETAILS_TEMPLATE_ID_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-template-id`;
export const CAMPAIGN_HEADER_DETAILS_LOCALES_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-locales`;
export const CAMPAIGN_HEADER_DETAILS_EXPERIMENTS_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-experiments`;
export const CAMPAIGN_HEADER_DETAILS_MESSAGE_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-message`;
export const CAMPAIGN_HEADER_DETAILS_PLACEMENT_TEST_ID = `${CAMPAIGN_HEADER_DETAILS_TEST_ID}-placement`;
export const CAMPAIGN_HEADER_LABELS_TEST_ID = `${CAMPAIGN_HEADER_TEST_ID}-labels`;
